import React, { useEffect, useReducer, useState } from 'react'
import EncounterRightPortion from './EncounterRightPortion/EncounterRightPortion'
import { connect } from 'react-redux';
// import { TabActionEncounters } from '../../../../../actions/BillingActions';
import Table from '../../../../Setup/Shared/Table';
import GridColumnHeader from '../../../../Setup/Shared/GridColumnHeader';
import usePagination from '../../../../../customhooks/usePagination';
import isNull from '../../../../../utils/NullChecking';
import SearchHeader from '../../../../Setup/Shared/SearchHeader';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../../utils/Enum';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import ReloadGridAction from '../../../../../actions/ReloadGridAction';
import DataGrid from "react-data-grid";
import { Modal } from "react-bootstrap";
import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import DatePicker from '../../../../General/DatePicker';
import ModalHeader from '../../../../Setup/Shared/ModalHeader';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { format } from 'date-fns';
import FormValidator from '../../../../../utils/FormValidator';
import SuperSearchMultipleServer from '../../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer';
import SuperSearchSingleClient from '../../../../shared/SuperSearch/SingleSelection/SuperSearchSingleClient';
import DropdownValueHandler from '../../../../shared/SuperSearch/DropdownValueHandler';
import Loader from '../../../../shared/Loader/Loader';
import { createPortal } from 'react-dom';
import NoDataFound from '../../../../shared/NoDataFound/NoDataFound';
// import { noteTypes } from './EncounterRightPortion/TemplateView/Components/Constants';
import DeleteConfirmatiom from '../../../../General/DeleteConfirmation';
import { FindFirstChild } from '../../../../../utils/FindMenuOption';
import handleSetDropdownData from '../../../../../utils/HandleSetDropdownData';
import CurrentMaxDateValidator from '../../../../../utils/CurrentMaxDateValidator';
import { isChildWindow } from '../../../../../utils/Constants';
// import Encounter from './EncounterRightPortion/TemplateView/EncounterRight';

const EncounterSearch = ({
    templateDataToApply,
    setTemplateDataToApply,
    ...props }) => {
    let dispatch = useDispatch();
    let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    let OpenedPatients = useSelector(state => state.Open_Patient_Tab);
    const API_URL = enumUtil.controller.General;
    const API_URL_PATIENT = enumUtil.controller.PATIENT
    const API_URL_PatientEncounter = enumUtil.controller.PatientEncounter;
    let isViewAllowed = FindFirstChild('Patient', 'Encounter')?.ISView
    let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted


    let ENCOUNTER_DEFAULT_MODEL = {
        SOAP : {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "",
                "EncounterDate": "",
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                "ChiefComplaint": "",
                "SubjectiveNotes": "",
                "ObjectiveNotes": "",
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": ""
            },
            // "Vital": [],
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[],
            // "CognitiveStatus":[],
            // "FunctionalStatus":[],
        },
        GIRP: {
            "TableName": enumUtil.enumAPITableName.GIRPNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "GIRP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "GoalsNotes": "",
                "InterventionNotes": "",
                "ResponseNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        BIRP: {
            "TableName": enumUtil.enumAPITableName.BIRPNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "BIRP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "BehaviourNotes": "",
                "InterventionNotes": "",
                "ResponseNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        DAP : {
            "TableName": enumUtil.enumAPITableName.DAPNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "DAP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "DataNotes": "",
                "AssesmentNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        DAPP : {
            "TableName": enumUtil.enumAPITableName.DAPPNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "DAPP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "DataNotes": "",
                "AssesmentNotes": "",
                "ProgressNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        Therapy : {
            "TableName": enumUtil.enumAPITableName.TherapyNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "Therapy",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "",
                "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "SubjectiveNotes": "",
                "ObjectiveNotes": "",
                "InterventionNotes": "",  
                "ResponseNotes": "",      
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": "",
    
                "FollowUpDate" : "",
                "FollowUpNotes" : ""
            },
            // "EncounterProblem": [],
            // "CurrentMentalStatus": {},
            // "InterventionsUsed": {},
            // "ResponseObservations": {},
            // "RiskAssessment": [],
    
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        Massage:{
            "TableName": enumUtil.enumAPITableName.MassageNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "Massage",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "SubjectiveNotes": "<p><strong>Symptoms:</strong></p><p><strong>Pain Level:</strong></p><p><strong>Aggravating/Relieving Factors:</strong></p><p><strong>Functional Limitations/Improvements:</strong></p><p><strong>Any Social/lifestyle factors if relevant:</strong></p>",
                "ObjectiveNotes": "",
                "InterventionNotes": "",  
                "ResponseNotes": "",      
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": "",
    
                "FollowUpDate" : "",
                "FollowUpNotes" : ""
            },
            // "EncounterProblem": [],
            // "ObjectiveFinding": {},
            // "RangeOfMotion": {},
            // "AssessmentMethodUsed": {},
            // "AssessmentAreaTreated": {},
    
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        Physical:{
            "TableName": enumUtil.enumAPITableName.PhysicalNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "Physical",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "SubjectiveNotes": "<p><strong>Symptoms:</strong></p><p><strong>Pain Level:</strong></p><p><strong>Aggravating/Relieving Factors:</strong></p><p><strong>Functional Limitations/Improvements:</strong></p><p><strong>Any Social/lifestyle factors if relevant:</strong></p>",
                "ObservationNotes":"<p><strong>Posture/Gait:</strong></p><p><strong>Movement:</strong></p><p><strong>Symmetry:</strong></p>",
                "PalpationNotes":"",
                "ObjectiveNotes": "",
                // "InterventionNotes": "",  
                // "ResponseNotes": "",      
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": "",
    
                "FollowUpDate" : "",
                "FollowUpNotes" : ""
            },
            // "EncounterProblem": [],
            // "RangeOfMotion": {},
            // "Strength": {},
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        Other: {
            "TableName": enumUtil.enumAPITableName.OtherNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "Other",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "",
                // "VitalUnitType": "US Customary",
                "ChiefComplaint": "",
                "OtherNote": "",
            },
            // "Vital": [],
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        CustomNote: {
            "TableName": enumUtil.enumAPITableName.CustomNote,
            "Data": {
                "EncounterID": "",
                "PatientID": PatientIDR || "",
                "EncounterType": "",
                "NoteType": "CustomNote",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                "ChiefComplaint": "",
                // "VitalUnitType":"US Customary",
                // "BehaviourNotes": "",
                // "InterventionNotes": "",
                // "ResponseNotes": "",
                // "PlanNotes": "",
            },
        },
    }
    
    let EncounterIDR =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
                ?.data?.id
        );
    let AddEncounterPopup =
        useSelector(state => {
            let popupData = state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
                ?.data?.AddEncounterPopup;
            if (popupData?.active) {
                return popupData?.data;
            } else {
                return null
            }
        });

    let AddEncounterPopups =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
        );

    const API_URL_GENERAL_Patient = enumUtil.controller.Patient;
    const [patientBody, setPatientBody] = useState({
        "TableName": enumUtil.enumAPITableName.Patient,
        "SearchParam": '',
    });
    const [searchText, setSearchText] = useState('')
    const [patientID, setPatientID] = useState(null)
    const { paginationSection, PerPage, PageNo, TotalPages, Counts, setCounts, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, } = usePagination(props?.Settings?.PaginationDefaultRows);
    let reloadGrid = useSelector(state => state.ReloadGridReducer)
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })

    const [isEncounterExistConfirmation, setIsEncounterExistConfirmation] = useState(false);
    const [encountersData, setEncountersData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSearch, setIsLoadingSearch] = useState(false);
    ///Search///

    const SearchCriteria = {
        "EncounterDate": "",
        "EncounterType": "",
        "NoteType": "",
    }
    const [searchParam, setSearchParam] = useState(SearchCriteria)
    // const visitTypes = [
    //     { display: "Office Visit", value: "Office Visit" },
    //     { display: "Follow-up", value: "Follow-up" },
    //     { display: "New Patient Visit", value: "New Patient Visit" },
    //     { display: "Annual Wellness Visit", value: "Annual Wellness Visit" },
    //     { display: "Telehealth", value: "Telehealth" },
    // ];
    
    const API_URL_GENERAL = enumUtil.controller.General;
    const [encountersDDData, setEncountersDDData] = useState([]);
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType)
    let providerDD = useSelector(state => state.GeneralDropDownsReducer.Provider);
    let locationDD = useSelector(state => state.GeneralDropDownsReducer.Location);
    const [is, setIs] = useState(true);
    let valModal = {}
    let ValidationModal = {
        PatientIDVal:"",
        EncounterTypeVal: "",
        NoteTypeVal: "",
        EncounterDateVal: "",
        PatientAppointmentIDVal: "",
        SeenByVal: "",
        FacilityVal: "",
    }
    const [encounterDetailsValidationModal, setEncounterDetailsValidationModal] = useState(ValidationModal)
    const [hasReloaded, setHasReloaded] = useState(false);
    const defaultNote = noteTypes[0];
    const ENCOUNTER_MODEL = {
        "PatientID": props?.patientID,
        "CopyFromEncounterID": null,
        "EncounterType": "",
        "NoteType": defaultNote?.value || "SOAP",
        "EncounterDate": '',
        "SeenBy": "",
        "Facility": "",
        "PatientAppointmentID": "",
        "EncounterStatus": "In Progress",
    }
    const [demoData, setDemoData] = useState({
        "SeenBy": "",
        "Facility": "",
    });
    const [saveEncounterParam, setSaveEncounterParam] = useState(ENCOUNTER_MODEL);
    const SearchEncounterName = {
        "PatientID":"",
        "CopyFromEncounterID": null,
        "EncounterType": "",
        "NoteType": defaultNote?.display || "SOAP Note",
        "SeenBy": "",
        "Facility": "",
        "PatientAppointmentID": "",
        "EncounterStatus": "In Progress",
    }
    const [searchValue, setSearchValue] = useState(SearchEncounterName)

    const [openNewEncounterPopup, setOpenNewEncounterPopup] = useState(false);
    const [selectedOption, setSelectedOption] = useState("SelectDate");
    const API_URL_Patient = enumUtil.controller.Patient
    const [appointmentData, setAppointmentData] = useState([])
    // const [duplicateError, setDuplicateError] = useState(false)
    const [appointmentIDValue, setAppointmentIDValue] = useState([])
    const [gridDeleteID, setGridDeleteID] = useState();
    const [isOpenDeleteGrid, setIsOpenDeleteGrid] = useState(false);
    const [del, setDel] = useState(false);
    // const [isClose, setIsClose] = useState();
    // Settings?.PaginationDefaultRows
    const rowClass = () => { return "row-bg" }
    const columns =
        [
            {
                key: 'EncounterDate',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Date'} sortIcon={true} type={'string'} colKey={'EncounterDate'} data={encountersData} setData={setEncountersData} />),
                renderCell: ({ row }) => {
                    return (<button className="btn btn-link w-100" onClick={() => handleOpenEncounter(row)}>{`${row.EncounterDate}`}</button>)
                },
                resizable: true,
            },
            {
                key: 'EncounterType',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Encounter Type'} sortIcon={true} type={'string'} colKey={'EncounterType'} data={encountersData} setData={setEncountersData} />),
                renderCell: ({ row }) => {
                    return (<>{row.EncounterType}</>)
                },
                resizable: true,
            },
            {
                key: 'NoteType',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Note Type'} sortIcon={true} type={'string'} colKey={'NoteType'} data={encountersData} setData={setEncountersData} />),
                renderCell: ({ row }) => {
                    return (<>{row.NoteType}</>)
                },
                resizable: true,
            },
            {
                key: 'SeenBy',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Provider'} sortIcon={true} type={'string'} colKey={'SeenBy'} data={encountersData} setData={setEncountersData} />),
                renderCell: ({ row }) => {
                    return (<>{row.SeenBy}</>)
                },
                resizable: true,
            },
            {
                key: 'LocationName',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Location'} sortIcon={true} type={'string'} colKey={'LocationName'} data={encountersData} setData={setEncountersData} />),
                renderCell: ({ row }) => {
                    return (<>{row.LocationName}</>)
                },
                resizable: true,
            },
            {
                key: 'EncounterStatus',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-Icon-awesome-user-tie'} headerName={'Status'} sortIcon={true} type={'string'} colKey={'EncounterStatus'} data={encountersData} setData={setEncountersData} />),
                renderCell: ({ row }) => {
                    return (<>{row.EncounterStatus === 'Signed' ?
                        <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                        row.EncounterStatus === 'In Progress' ?
                            <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                            row.EncounterStatus === 'Ready for Review' ?
                                <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> : 
                            row.EncounterStatus === "To Be Co-Signed" ?
                                <p className='pill Transfer-to-Insurance'>To be Co-Signed</p> :
                                ['Unsigned', 'UnSigned'].includes(row.EncounterStatus) &&
                                <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}</>)
                },
                resizable: true,
            },
            {
                key: 'UpdatedBy',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={encountersData} setData={setEncountersData} />),
                resizable: true,
            },
            {
                key: 'UpdateDate',
                name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                    iconName={'icon-card'} headerName={'Updated Date'} sortIcon={true} type={'date'} colKey={'UpdateDate'} data={encountersData} setData={setEncountersData} />),
                resizable: true,
            },
            {
                key: 'Action',
                name: (<GridColumnHeader iconName={''} headerName={'Action'} sortIcon={false} />),
                resizable: true,
                renderCell({ row }) {
                    const rowID = row.BillingDocumentID
                    return (
                        <>
                            <div className="d-flex align-items-center gap-1 ar-billing_doc">
                                <i className={IsDeleteAllowed ? "icon-delete text-danger fs-12" : "icon-delete text-danger fs-12 disable"} onClick={() => handleDeleteGridModal(row?.EncounterID)}></i>
                            </div>
                        </>
                    )
                }
            },
            // {
            //     key: 'ChiefComplaint',
            //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
            //         iconName={'icon-Icon-awesome-user-tie'} headerName={'Chief Complaint'} sortIcon={true} type={'string'} colKey={'ChiefComplaint'} data={encountersData} setData={setEncountersData} />),
            //     renderCell: ({ row }) => {
            //         return (<>{row.ChiefComplaint}</>)
            //     },
            //     resizable: true,
            // },
        ];


    const handleDeleteGridModal = (ID) => {
        if (!IsDeleteAllowed) return
        setGridDeleteID(ID)
        setIsOpenDeleteGrid(true)
    }

    const LoadDDData = () => {
        // setIsLoading(true);
        setEncountersDDData([])
        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": props?.patientID,
            "SearchCriteria": {
                "Param": "PastEncounter"
            }
        })
            .then((response) => {
                // setIsLoading(false);
                setEncountersDDData(response.Rows);
                // setIs(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }

    const LoadData = (showLoader) => {
        if (!isViewAllowed) return
        if (showLoader === "showLoader") {
            setIsLoadingSearch(true);
        }
        if (patientID && patientID !== PatientIDR) return;
        ServerRequestProtected(API_URL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": PatientIDR,
            "PageNo": PageNo,
            "PerPage": PerPage,
            "SearchCriteria": {
                "Param": "All Encounter",
                "Search": searchText || '',
            }
        })
            .then((response) => {
                if (showLoader === "showLoader") {
                    setIsLoadingSearch(false);
                }
                handleGridHeader({ defaultData: response.Rows })
                setTotalPages(response.count.NumOfPages);
                setEncountersData(response.Rows);
                setDel(false);
                // setIs(true);
            }).catch((error) => {
                if (showLoader === "showLoader") {
                    setIsLoadingSearch(false);
                }
                setEncountersData([])
            })
    }
    const LoadDemographicsData = () => {
        if (patientID && patientID !== PatientIDR) return;
        ServerRequestProtected(API_URL + "/FindByID", 'post', {
            "ID": PatientIDR,
            "TableName": enumUtil.enumAPITableName.Encounter
        }).then(response => {
            setDemoData({
                SeenBy: response?.ProviderID + "",
                Facility: response?.LocationID + "",
            });
            setSearchValue(prev => ({...prev , PatientID: response?.display || ""}))
            // if(selectedOption === "SelectDate"){
            //     setSaveEncounterParam({ ...saveEncounterParam, 
            //         SeenBy: response?.ProviderID + "" ,
            //         Facility: response?.LocationID + "" ,
            //     });

            //     let providerSearchVal = DropdownValueHandler(providerDD, response.ProviderID)
            //     let locationSearchVal = DropdownValueHandler(locationDD, response.LocationID)
            //     setSearchValue(prev => ({ ...prev, 
            //         SeenBy: providerSearchVal + "" ,
            //         Facility: locationSearchVal + "" ,
            //     }));
            // }
        }).catch(error => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            // setIsLoading(false)
        })
    }
    const SearchByParam = (showLoader) => {
        if (!isNull(searchParam)) {
            handlePageClick('1')
            // LoadData(searchParam)
            LoadData(showLoader)
        } else {
            LoadData(showLoader)
        }
    }

    const clearFilter = () => {
        setSearchParam(SearchCriteria);
    }

    const handleOpenEncounter = (encounter) => {
        // if (isChildWindow) return;
        let obj = {
            active: true,
            key: 2,
            name: "Encounter",
            data: {
                name: `${encounter.EncounterDate}`,
                id: encounter.EncounterID,
                // patID: PatientIDR,
                type: encounter.NoteType,
                time: new Date()
            },
        }
        // dispatch(TabActionEncounters(obj));      
        dispatch({
            type: 'Open_Encounter_Tab',
            payload: {
                patientId: PatientIDR,     // <-- needed to find the patient tab to update
                tab: obj,            // the encounter tab object
                groupEncounter: {
                    isGroupEncounter: encounter.isGroupEncounter,
                    GroupIdentifier: encounter.GroupIdentifier
                }
            }
        });
    }

    const handleApplyDemoData = () => {
        setSaveEncounterParam({
            ...saveEncounterParam,
            SeenBy: demoData?.SeenBy + "",
            Facility: demoData?.Facility + "",
        });
        let providerSearchVal = DropdownValueHandler(providerDD, demoData?.SeenBy) || "";
        let locationSearchVal = DropdownValueHandler(locationDD, demoData?.Facility) || "";
        setSearchValue(prev => ({
            ...prev,
            SeenBy: providerSearchVal + "",
            Facility: locationSearchVal + "",
        }));
    }

    const handleAddNewEncounter = (openedFrom) => {
        if (!IsEditAllowed) return;
            if (patientID && patientID !== PatientIDR) return;
            setOpenNewEncounterPopup(true);
            if (selectedOption === "SelectDate") {
                handleApplyDemoData();
            }
            if (openedFrom === 'Clear_Add_Encounter_Popup') {
                dispatch({
                    type: 'Clear_Add_Encounter_Popup',
                    payload: {
                        patientId: PatientIDR,
                        encounterId: 0 // Assuming you're always opening on "All Encounter"
                    }
                });
            }
        // }
    }

    const handleSelectDateOption = (e) => {
        setSelectedOption(e.target.value);
        // To Remove Demo Applied Data in case of Select Appointment and Apply in Select Date
        if (selectedOption === "SelectDate" && e.target.value === "SelectAppointment") {
            setSaveEncounterParam(prev => ({...ENCOUNTER_MODEL, PatientID:prev.PatientID || ""}));
            setSearchValue(prev => ({...SearchEncounterName, PatientID:prev.PatientID || ""}));
        } else if (selectedOption === "SelectAppointment" && e.target.value === "SelectDate") {
            handleApplyDemoData();
        }
    }

    const handleCloseEncounterPopup = () => {
        setOpenNewEncounterPopup(false);
        setEncounterDetailsValidationModal(ValidationModal);
        setSaveEncounterParam(ENCOUNTER_MODEL);
        setSearchValue(prev => ({...SearchEncounterName, PatientID:prev.PatientID || ""}));
        setSelectedOption("SelectDate");
    }

    // useEffect(() => {
    //     setIs(true);
    //     LoadData("showLoader");
    // }, [PerPage, PageNo])

    // useEffect(() => {
    //     if(!props?.patientID) return;
        
    //     ServerRequestProtected(API_URL_Patient + "/InstantSearchWithDetails", 'post', {
    //         "TableName": enumUtil.enumAPITableName.Patient,
    //         "SearchParam": "faiza"
    //     })
    //     .then((response) => {
    //         setSearchValue(prev => ({...prev , PatientID: response?.[0]?.display || ""}))
    //     }).catch((error) => {
    //     })

    // },[props?.patientID])

    useEffect(() => {
        if (!del) return;
        setIs(true);

        let encExist = OpenedPatients?.find(pat => pat.data.id === patientID)?.Open_Encounter_Tab?.find(enc => (enc.data.id == gridDeleteID));
        if (encExist) {
            dispatch({
                type: 'Close_Encounter_Tab',
                payload: {
                    patientId: patientID,      // Replace with the actual patient's ID
                    encounterId: gridDeleteID         // Replace with the encounter tab ID to close
                }
            });
        }
        LoadData("showLoader");
    }, [del])

    useEffect(() => { props.setRecordsNum(encountersData.length) }, [encountersData])
    ////Reload on Save
    useEffect(() => {
        if (reloadGrid?.EncounterSearch === true) {
            LoadData(searchParam);
            dispatch(ReloadGridAction({ EncounterSearch: false }));
        }
    }, [reloadGrid?.EncounterSearch])

    const EncounterName = () => {
        return (
            <p className="heading">New Encounter</p>
        )
    }


    const handleSave = async (updatedParams) => {
        console.log("handleSave123", saveEncounterParam)
        if(!IsEditAllowed) return
        const valModal = await EncounterDetailsValidation(); // call child's validate
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            return
        } else {
            setIsLoading(true)
            const getStructerdSaveData = () => {

                // let existingNotes = ["SOAP", "GIRP","BIRP","DAP","DAPP", "Therapy", "Massage", "Physical","Other"]
                let existingNotes = new Set(Object.keys(ENCOUNTER_DEFAULT_MODEL).filter(key => key !== "CustomNote"));
                const noteType = saveEncounterParam?.NoteType;
                let currentNote = existingNotes.has(noteType) ? noteType : "CustomNote";
                // console.log("restObjsaveEncounterParam?.NoteType ", currentNote )

                let { Data, ...restObj } = { ...ENCOUNTER_DEFAULT_MODEL?.[currentNote]  };

                // console.log("restObj", restObj )
                let { UpdateDate, UpdatedBy, TableName, ...data } = { ...Data };
                Data = {
                    ...data,
                    // "ChiefComplaint": "",
                    ...saveEncounterParam,
                    // "SubjectiveNotes": "",
                    // "ObjectiveNotes": '',
                    // "AssesmentNotes": '',
                    // "PlanNotes": '',
                    // "AdditionalInfoNotes": '',
                };
                restObj = {
                    ...restObj,
                    // "Vital": [],
                    // "EncounterProblem": [],
                    // "EncounterDocument": [],
                }

                // setAddVital(false);
                return { ...restObj, Data };
            }
            let saveData = getStructerdSaveData();
            if(updatedParams?.SaveDuplicateEncounter === "true"){
                saveData.Data.SaveDuplicateEncounter = updatedParams.SaveDuplicateEncounter;
            }
            console.log("handleEncounterExists saveData", updatedParams);
            console.log("saveData", saveData)
            let API_URL_NOTE = saveEncounterParam?.NoteType === 'SOAP' ?
                            "/SaveSOAPEncounter" :
                            saveEncounterParam?.NoteType === 'GIRP' ?
                                "/SaveGIRPNote" :
                                saveEncounterParam?.NoteType === 'BIRP' ?
                                    "/SaveBIRPNote" :
                                    saveEncounterParam?.NoteType === 'DAPP' ?
                                        "/SaveDAPPNote" :
                                        saveEncounterParam?.NoteType === 'DAP' ?
                                            "/SaveDAPNote" :
                                            saveEncounterParam?.NoteType === 'Therapy' ?
                                                "/SaveTherapyNote" :
                                                saveEncounterParam?.NoteType === 'Massage' ?
                                                    "/SaveMassageNote" :
                                                    saveEncounterParam?.NoteType === 'Physical' ?
                                                        "/SavePhysicalNote" :
                                                        saveEncounterParam?.NoteType === 'Other' ?
                                                            "/SaveOtherNote" : "/SaveCustomNote";

            ServerRequestProtected(API_URL_PatientEncounter + API_URL_NOTE, 'post', {
                ...saveData
            })
                .then((response) => {
                    setIsLoading(false);
                    createPortal(
                        NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success),
                        document.getElementById('root')
                    );
                    let obj = {
                        active: true,
                        key: 2,
                        name: "Encounter",
                        data: {
                            id: response.id,
                            name: saveEncounterParam.EncounterDate,
                            type: saveEncounterParam.NoteType,
                            time: new Date(),
                        },
                    }
                    dispatch({
                        type: 'Open_Encounter_Tab',
                        payload: {
                            patientId: PatientIDR,     // <-- needed to find the patient tab to update
                            tab: obj            // the encounter tab object
                        }
                    });
                    handleCloseEncounterPopup();
                    // setReloadAfterSave(true);
                    dispatch(ReloadGridAction({ EncounterSearch: true }));
                }).catch((error) => {
                    // setDuplicateError(error?.response?.data === "An encounter already exists for the selected date")
                    // EncounterDetailsValidation(error?.response?.data);
                    setIsLoading(false)
                    console.log("Error Error", error?.response?.data)
                    if(error?.response?.data === "An encounter already exists for the selected date"){
                        handleEncounterExists(saveData.Data.EncounterDate);
                    } else {
                        error?.response?.data && NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
                    }
                })
        }
    }

    /////// Encounter Save ////////


    const API_URL_General = enumUtil.controller.General

    const LoadDD = () => {
        if (patientID && patientID !== PatientIDR) return;
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": PatientIDR,
        })
            .then((response) => {
                setAppointmentData(response)
                // setPatientID(PatientIDR);
            }).catch((error) => {
            })
    }
    useEffect(() => {
        setPatientID(PatientIDR);
    }, [])

    useEffect(() => {
        console.log("prop reload LoadDDAndDemoData")
        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadDemographicsData();
                    LoadDDData();
                    LoadDD();
                    LoadData();
                }
            })
            if (data.length === 0) {
                LoadDemographicsData();
                LoadDDData();
                LoadDD();
                LoadData();
            }
        }
    }, [props.Reload, PerPage, PageNo])

    ////Reload on AppointmentSave
    useEffect(() => {
        if (reloadGrid?.AppointmentListEncounter === true) {
            LoadDDData();
            LoadDD();
            setHasReloaded(true);
            dispatch(ReloadGridAction({ AppointmentListEncounter: false }));
        }
    }, [reloadGrid?.AppointmentListEncounter])

    useEffect(() => {
        if (!reloadGrid.AppointmentListEncounter && hasReloaded) {
            setHasReloaded(false); // allow future triggers again
        }
    }, [reloadGrid.AppointmentListEncounter]);

    const handleApplyAddEncounterPopupAppointmentData = () => {
        if (patientID && patientID !== PatientIDR) return;
        if(IsEditAllowed){
            setSelectedOption("SelectAppointment");
            setOpenNewEncounterPopup(true);
            setSaveEncounterParam({
                ...saveEncounterParam,
                PatientAppointmentID: AddEncounterPopup?.PatientAppointmentID + "",
                SeenBy: AddEncounterPopup?.SeenBy + "",
                Facility: AddEncounterPopup?.Facility + "",
                EncounterDate: AddEncounterPopup?.EncounterDate,
                ChiefComplaint: AddEncounterPopup?.ChiefComplaint,
            })

            let providerSearchVal = DropdownValueHandler(providerDD, AddEncounterPopup.SeenBy)
            let locationSearchVal = DropdownValueHandler(locationDD, AddEncounterPopup.Facility)
            setSearchValue(prev => ({
                ...prev,
                PatientAppointmentID: AddEncounterPopup.EncounterDate + "",
                SeenBy: providerSearchVal + "",
                Facility: locationSearchVal + "",
            }));
        }

        dispatch({
            type: 'Clear_Add_Encounter_Popup',
            payload: {
                patientId: PatientIDR,
                encounterId: 0 // Assuming you're always opening on "All Encounter"
            }
        });
    }

    useEffect(() => {
        if (!AddEncounterPopup || !AddEncounterPopup?.PatientAppointmentID || AddEncounterPopup?.Action) return; // prevent when cleared (when PatientAppointmentID doesn't exist)
        handleApplyAddEncounterPopupAppointmentData();
    }, [AddEncounterPopup])

    useEffect(() => {
        let demoExist = (demoData?.SeenBy && demoData?.Facility);
        if (!demoExist) {
            console.log("Demo data not ready yet");
        }
        if (!AddEncounterPopup || AddEncounterPopup?.Action !== 'ApplyDemoData' || !demoExist) return; // prevent when Action is not 'ApplyDemoData'
        handleAddNewEncounter('Clear_Add_Encounter_Popup');
    }, [AddEncounterPopup, demoData])

    const handlePatientSearchChange = (e) => {
        setIs(false)
        // searchValue.PatientID = e.target.value
        setSearchValue(prev => ({ ...prev, PatientID:e.target.value}))
        setPatientBody({ "TableName": enumUtil.enumAPITableName.Patient, "SearchParam": e.target.value })
        
    }
    const handleSelectedData = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            setIs(true);

            if (name === 'CopyFromEncounterID') {
                if([ -1, "-1"].includes(selectedData.value)){
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
                    setSearchValue(prev => ({ ...prev, [name]: "" }))
                } else {
                    console.log("CopyFromEncounterID",selectedData, visitTypes)
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: selectedData.value + "", 
                        NoteType: selectedData.NoteType + "",
                        SeenBy: selectedData.ProviderID + "",
                        Facility: selectedData.LocationID + "",
                        EncounterType: selectedData.EncounterTypeID + "",
                        
                    })

                    let providerSearchVal = DropdownValueHandler(providerDD, selectedData.ProviderID)
                    let locationSearchVal = DropdownValueHandler(locationDD, selectedData.LocationID);
                    let visitSearchVal = DropdownValueHandler(visitTypes, selectedData.EncounterTypeID);
                    
                    setSearchValue(prev => ({ ...prev, [name]: selectedData.display + "", 
                        NoteType: (noteTypes.find(note => note?.value === selectedData.NoteType)?.display || '') + "",
                        SeenBy: providerSearchVal + "",
                        Facility: locationSearchVal + "",
                        EncounterType: visitSearchVal + "",  
                    }))
                }
            }
            if (name === 'EncounterType') {
                setSaveEncounterParam({ ...saveEncounterParam, EncounterType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterType: selectedData.display + "" }))
            }
            if (name === 'NoteType') {
                setSaveEncounterParam(prev => {
                // remove EHRTemplateID from previous state
                const { EHRTemplateID, ...rest } = prev;
                return {
                    ...(selectedData.IsSystemGenerated ? rest : prev),
                    NoteType: String(selectedData.value),
                    ...(!selectedData.IsSystemGenerated && { EHRTemplateID: selectedData.EHRTemplateID}
                    )
                };});
                // setSaveEncounterParam({ ...saveEncounterParam, NoteType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, NoteType: selectedData.display + "" }))
            }
            if (name === 'SeenBy') {
                setSaveEncounterParam({ ...saveEncounterParam, SeenBy: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, SeenBy: selectedData.display + "" }))
            }
            if (name === 'Facility') {
                setSaveEncounterParam({ ...saveEncounterParam, Facility: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, Facility: selectedData.display + "" }))
            }
            if (name === 'PatientAppointmentID') {
                if([ -1, "-1"].includes(selectedData.value)){
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
                    setSearchValue(prev => ({ ...prev, [name]: "" }))
                } else {
                    setSaveEncounterParam({
                        ...saveEncounterParam,
                        PatientAppointmentID: selectedData?.value + "",
                        SeenBy: selectedData?.ProviderID + "",
                        Facility: selectedData?.LocationID + "",
                        EncounterDate: selectedData?.AppointmentDate,
                        ChiefComplaint: selectedData?.ChiefComplain,
                    })
                    let providerSearchVal = DropdownValueHandler(providerDD, selectedData.ProviderID)
                    let locationSearchVal = DropdownValueHandler(locationDD, selectedData.LocationID)
                    setSearchValue(prev => ({
                        ...prev,
                        PatientAppointmentID: selectedData.AppointmentDate + "",
                        SeenBy: providerSearchVal + "",
                        Facility: locationSearchVal + "",
                    }))
                }
            }
        } else if(type === 'server' && !isNull(selectedData)) {
            if (name === 'PatientID') {
                if ([ -1, "-1"].includes(selectedData.value)) {
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
                    setSearchValue(prev => ({ ...prev, [name]: "" }))
                } else {
                    console.log("selectedData 12",name,selectedData)
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: selectedData.value + "" })
                    setSearchValue(prev => ({ ...prev, [name]: selectedData.display + "" }))
                }
            }  
        } else {
            setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
            setSearchValue(prev => ({ ...prev, [name]: "" }))
        }
        return selectedData
    }
    const handleCalendarChange = (date) => {
        setSaveEncounterParam({ ...saveEncounterParam, EncounterDate: date + "" })
    }
    const EncounterDetailsValidation = async (duplicateErrorText) => {
        // let duplicateErrorBoolean = duplicateErrorText === "An encounter already exists for the selected date";
        let patientIDVal = [-1, '-1'].includes(saveEncounterParam.PatientID) ? '' : saveEncounterParam.PatientID;
        let encounterTypeVal = [-1, '-1'].includes(saveEncounterParam.EncounterType) ? '' : saveEncounterParam.EncounterType;
        let noteTypeVal = [-1, '-1'].includes(saveEncounterParam.NoteType) ? '' : saveEncounterParam.NoteType;
        let patientAppointmentVal = [-1, '-1'].includes(saveEncounterParam.PatientAppointmentID) ? '' : saveEncounterParam.PatientAppointmentID;
        let seenByVal = [-1, '-1'].includes(saveEncounterParam.SeenBy) ? '' : saveEncounterParam.SeenBy;
        let facilityVal = [-1, '-1'].includes(saveEncounterParam.Facility) ? '' : saveEncounterParam.Facility;

        let ValidationModal = {
            PatientIDVal: FormValidator(
                patientIDVal,
                enumUtil.enumValidationType.Required,
                'Patient',
            ),
            EncounterTypeVal: FormValidator(
                encounterTypeVal,
                enumUtil.enumValidationType.Required,
                'Encounter Type',
            ),
            NoteTypeVal: FormValidator(
                noteTypeVal,
                enumUtil.enumValidationType.Required,
                'Note Type',
            ),
            ...(selectedOption === "SelectAppointment" ?
                {
                    PatientAppointmentIDVal: FormValidator(
                        patientAppointmentVal,
                        enumUtil.enumValidationType.Required,
                        'Patient Appointment',
                    )
                } :
                {
                    EncounterDateVal: isNull(saveEncounterParam.EncounterDate) ?
                        FormValidator(
                            saveEncounterParam.EncounterDate,
                            enumUtil.enumValidationType.Required,
                            'Encounter Date',
                        ) :
                        CurrentMaxDateValidator(
                            saveEncounterParam.EncounterDate,
                            enumUtil.enumValidationType.CurrentDate,
                            'Encounter Date',
                        )
                })
            ,
            SeenByVal: FormValidator(
                seenByVal,
                enumUtil.enumValidationType.Required,
                'Provider',
            ),
            FacilityVal: FormValidator(
                facilityVal,
                enumUtil.enumValidationType.Required,
                'Location',
            )
        }
        valModal = ValidationModal
        await setEncounterDetailsValidationModal(ValidationModal)
        return valModal;
    }
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    }
    const handleSearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam("showLoader");
        }
    }

    const onCloseDeleteGrid = () => {
        setDel(true);
        setIsOpenDeleteGrid(false)
    }
    const onCloseGrid = () => {
        setIsOpenDeleteGrid(false)
    }
    let DeleteConfirmationGrid = "";
    if (isOpenDeleteGrid) {
        DeleteConfirmationGrid = <DeleteConfirmatiom isOpenAlert={isOpenDeleteGrid} onCloseDelete={onCloseGrid} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Encounter} ID={gridDeleteID} onClose={onCloseDeleteGrid} Messsage={true} hideReason={true} />
    }

    const confirmationMsg = (EncounterDate) => {
        return new Promise((resolve, reject) => {
            const handleConfirmation = (userConfirmed) => {
                if (userConfirmed) {
                    resolve(userConfirmed);
                } else { reject(userConfirmed); }
                setIsEncounterExistConfirmation(<></>);
            };
            setIsEncounterExistConfirmation(
                <Modal show={true} onHide={() => handleConfirmation(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
                    <ModalHeader HeaderName={Heading} DeletePopup={""} isClosed={() => handleConfirmation(false)} key={6331} Name={'DuplicateEncounter'} />
                    <Modal.Body>
                        <div className='ar-alert d-flex mb-12'>
                            <i className='icon-Vector13 mt-1'></i>
                            <div>
                                <p className='text ms-1'>Encounter already exists for {EncounterDate}. Do you want to create another encounter?</p>
                            </div>
                        </div>
                    </Modal.Body>

                    <div className="modal_footer za_br_light br-top-1 pt-2 ">
                        <div className='za-button text-end d-flex justify-content-end gap-2'>
                            <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => handleConfirmation(false)}>No</button>
                            <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleConfirmation(true)}>Yes</button>
                        </div>
                    </div>
                </Modal>)
        })
    }
    
    const Heading = () => {
        return <p className='heading Rejected_clr'>Confirmation Message</p>;
    };

    const handleEncounterExists = async(EncounterDate) => {
        const userConfirmed = await confirmationMsg(EncounterDate);
        console.log("handleEncounterExists", userConfirmed);
        if(userConfirmed){
            let updatedParams = { ...searchParam, SaveDuplicateEncounter: "true" };
            setSearchParam(() => updatedParams);
            handleSave(updatedParams);
        }
    }

    return (
        <>
            {isEncounterExistConfirmation}
            {DeleteConfirmationGrid}
            {/* <Encounter 
    templateDataToApply={templateDataToApply} setTemplateDataToApply={setTemplateDataToApply} 
    {...props}/> */}

            {/* <EncounterRightPortion
    templateDataToApply={templateDataToApply} setTemplateDataToApply={setTemplateDataToApply} 
    {...props}/> */}
            <div className="container-fluid py-2">
                <div className='row align-items-end'>
                    <div className="col-md-12 hk-opt-bar">
                        <div className="row row-half row-gap-15 align-items-end">
                            {/* <div className="col-md-2">
                            <div className='input'>
                                <label>Encounter Date</label>
                                <div class="input-group">
                                    <input type="text"
                                        name="EncounterDate"
                                        id="EncounterDate"
                                        class="form-control fc-xs"
                                        value={searchParam.EncounterDate}
                                        onChange={(e) => { setSearchParam({ ...searchParam, EncounterDate: e.target.value }) }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className='input'>
                                <label>Encounter Type</label>
                                <div class="input-group">
                                    <input type="text"
                                        name="EncounterType"
                                        id="EncounterType"
                                        class="form-control fc-xs"
                                        value={searchParam.EncounterType}
                                        onChange={(e) => { setSearchParam({ ...searchParam, EncounterType: e.target.value }) }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className='input'>
                                <label>Note Type</label>
                                <div class="input-group">
                                    <input type="text"
                                        name="NoteType"
                                        id="NoteType"
                                        class="form-control fc-xs"
                                        value={searchParam.NoteType}
                                        onChange={(e) => { setSearchParam({ ...searchParam, NoteType: e.target.value }) }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 d-flex justify-content-between align-items-center pe-3">
                            <div>
                                <div className="btns-group-flex">
                                    <div className='btns-group-flex'>
                                        <div className="d-flex position-relative">
                                            <button className='btn btn-orange btn-xs no-width ar_rounded' onClick={SearchByParam}>Search</button>
                                            <span className="clera_btn">
                                            </span>
                                        </div>
                                        <div className="line-border">
                                        </div>
                                        <button className='btn btn-outline btn-xs no-width rounded me-1' onClick={clearFilter}>Clear</button>
                                    </div>
                                </div>
                            </div>
                            <div>
                            </div>
                        </div> */}
                            <div className={`col-md-6 form-rounded ps-3 ${isViewAllowed ? '' : 'disable'}`}>
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input
                                            type="text"
                                            name='searchText'
                                            id='searchText'
                                            className='form-control fc-xs'
                                            placeholder='Search by name or id…'
                                            value={searchText}
                                            onChange={handleSearchChange}
                                            onKeyDown={handleSearchOnEnter}
                                        />
                                        <span className="input-group-text" id="basic-addon2" onClick={() => SearchByParam("showLoader")}>
                                            <i className="bi bi-search"></i>
                                        </span>
                                        {/* <span className="input-group-text" id="basic-addon2">
                                            <i className="bi bi-x"></i>
                                        </span> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 d-flex justify-content-end">
                                <button class={IsEditAllowed ? "btn btn-orange btn-xs no-width rounded mb-0 d-flex align-items-center gap-1" : 'btn btn-orange btn-xs no-width rounded mb-0 d-flex align-items-center gap-1 disable'}
                                    onClick={handleAddNewEncounter}>
                                    <span class="fs-16 heading text-white">+</span>New Encounter
                                </button>
                                {/* diasbled class remove for live build will add after that */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" position-relative">
                {isLoadingSearch ? <Loader /> : null}
                {/* <Table
                    columns={columns}
                    // rows = {PaymentsData.length !== 0 ? [...encountersData ,footerRow] : encountersData}
                    rows={encountersData}
                    // bottomSummaryRows={bottomSummaryRows}
                    height='500px'
                    rowClass={rowClass}
                    dynamicClass='fill-grid DataGrid-Table hk-exp-table payment_table encounter-table'
                    // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table hk-amt-table payment_table'
                    rowHeight={25}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    Key={91}
                    Name={'Encounter'}
                    isLoading={isLoading}
                    hideColClass='payment-hide'
                    colPopup='top-0'
                    TableName={'Encounter'}
                    // handleSelectData={handleSelectData}
                    disableInput={true}
                /> */}
                <DataGrid
                    columns={columns}
                    rows={encountersData}
                    // onRowsChange={onRowsChange}
                    headerRowHeight={25}
                    rowHeight={25}
                    // className="fill-grid DataGrid-Table hk-exp-table submissio_history_table all_claims payment_table"
                    className='fill-grid DataGrid-Table hk-exp-table encounter-table'
                    enableVirtualization={false}
                    style={{ userSelect: "text", height: "465px" }}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                />
                {!isLoadingSearch ? (encountersData.length < 1) ?
                    <NoDataFound isLoading={isLoadingSearch} rows={encountersData} />
                    : null : null
                }
                {paginationSection}
            </div>

            <Modal show={openNewEncounterPopup} onHide={handleCloseEncounterPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 add_new_encounter_popup">
                <Modal.Body>
                    <ModalHeader HeaderName={EncounterName} DeletePopup={''} isClosed={handleCloseEncounterPopup} />
                    <div className="">
                        {isLoading ? <Loader /> : null}
                        <div className="d-flex align-items-center gap-15 mb-12">
                            <label className="ar_radio-btn d-flex align-items-center gap-6">
                                <input type="radio"
                                    name="appointmentOption"
                                    value='SelectAppointment'
                                    checked={selectedOption === "SelectAppointment"}
                                    onChange={handleSelectDateOption}
                                />
                                <span className="text ar-orange-text">Select Appointment</span>
                            </label>
                            <label className="ar_radio-btn d-flex align-items-center gap-6">
                                <input
                                    type="radio"
                                    name="appointmentOption"
                                    value='SelectDate'
                                    checked={selectedOption === "SelectDate"}
                                    onChange={handleSelectDateOption}
                                />
                                <span className="text ar-orange-text">Select Date</span>
                            </label>
                        </div>

                    </div>

                    <div className="d-flex flex-column gap-2">
                        <div className={`m-0 ${encounterDetailsValidationModal.PatientIDVal ? 'input error planSearch-module' : 'input planSearch-module'}`}>
                            <SuperSearchList
                                type='server'
                                id='PatientID'
                                name='PatientID'
                                searchValue={searchValue.PatientID}
                                ApiLink={API_URL_GENERAL_Patient + "/InstantSearchWithDetails"}
                                method='post'
                                postBody={patientBody}
                                onChange={handlePatientSearchChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                icon={true}
                                PatientDeatailedInst={true}
                                placeholder={"Search Patient..."}
                                inputError={encounterDetailsValidationModal.PatientIDVal}
                                isReadOnly={true}
                                disabled={true}
                            />
                            {encounterDetailsValidationModal.PatientIDVal}
                        </div>
                        {selectedOption === 'SelectAppointment' && (
                            <div className={`input form-group ar-multiple-br m-0 pateint-serach-no-rounded ${encounterDetailsValidationModal.PatientAppointmentIDVal ? 'error' : ''}`}>
                                <label className="pb-3px">Appointment</label>
                                {/* <SuperSearchList
                                    type="appointment"
                                    id="AppointmentTime"
                                    name="AppointmentTime"
                                    icon="Simple"
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                /> */}
                                {/* <SuperSearchMultipleServer
                                    // key={reloadSuperSearchPatient}
                                    id="PatientAppointmentID"
                                    name="PatientAppointmentID"
                                    SuperSearchView="DetailedView"
                                    DetailedView="Encounter"
                                    initialSelectedOptionsInstant={appointmentIDValue}
                                    searchParam={saveEncounterParam}
                                    setSearchParam={setSaveEncounterParam}
                                    tableName={enumUtil.enumAPITableName.Encounter}
                                    controller={API_URL_Patient}
                                    ApiLink={"/InstantSearchWithDetails"} //api url 
                                    method='post'  //   api method
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    inputError={encounterDetailsValidationModal.PatientAppointmentIDVal}
                                /> */}

                                {/* <label>Insurance</label> */}
                                {/* <SuperSearchSingleClient  
                                    // key={reloadSuperSearchPatient} 
                                    id="PatientAppointmentID"
                                    name="PatientAppointmentID"
                                    selectedOptionsDisplay='PatientAppointmentID'
                                    initialSelectedValues={appointmentIDValue}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={appointmentData}
                                    SuperSearchView="DetailedView"
                                    DetailedView="Encounter"
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                /> */}
                                <SuperSearchSingleClient
                                    type="client"
                                    id='PatientAppointmentID'
                                    name='PatientAppointmentID'
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    searchValue={searchValue.PatientAppointmentID}
                                    // data={appointmentData}
                                    data={handleSetDropdownData(appointmentData, {functions: ['setEmptyDefault']})}
                                    onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, PatientAppointmentID: e.target.value }) }}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    placeholder={false}
                                    SuperSearchView="DetailedView"
                                    DetailedView="PatientEncounterAppt"
                                    inputError={encounterDetailsValidationModal?.PatientAppointmentIDVal}
                                />
                                {encounterDetailsValidationModal.PatientAppointmentIDVal}
                            </div>)}

                        {selectedOption === 'SelectDate' && (

                            <div className={`input form-group m-0 w-100 ${encounterDetailsValidationModal.EncounterDateVal ? 'error' : ''}`}>
                                <label className="pb-3px">Date</label>
                                {/* <DatePicker /> */}
                                <DatePicker
                                    value={searchParam.EncounterDate}
                                    handleCalendarChangefunc={date => handleCalendarChange(date)}
                                    maxDate={new Date()}
                                    showLabel={false}
                                />
                                {encounterDetailsValidationModal.EncounterDateVal}
                            </div>)}

                        <div className={`form-group input mb-0`}>
                            <label className="pb-3px">Copy From</label>
                            <div className="input form-group ar-multiple-br m-0">
                                <div className="ar-multiple-br">
                                    <SuperSearchSingleClient
                                        type="client"
                                        id='CopyFromEncounterID'
                                        name='CopyFromEncounterID'
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        searchValue={searchValue.CopyFromEncounterID}
                                        data={handleSetDropdownData(encountersDDData, { functions: ['removeNegativeValue', 'removeSelfPay', 'setEmptyDefault'] })}
                                        onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, CopyFromEncounterID: e.target.value }) }}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        placeholder={false}
                                        SuperSearchView="DetailedView"
                                        DetailedView="PatientPastEncounter"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={`form-group input mb-0 ${encounterDetailsValidationModal.SeenByVal ? 'error' : ''}`}>
                            <label className="pb-3px">Provider</label>
                            <div className="input form-group ar-multiple-br m-0">
                                <SuperSearchList
                                    type="client"
                                    id='SeenBy'
                                    name='SeenBy'
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    searchValue={searchValue.SeenBy}
                                    data={providerDD}
                                    onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, SeenBy: e.target.value }) }}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    placeholder={false}
                                    inputError={encounterDetailsValidationModal?.SeenByVal}
                                />
                                {encounterDetailsValidationModal.SeenByVal}
                            </div>
                        </div>

                        <div className={`form-group input mb-0 ${encounterDetailsValidationModal.FacilityVal ? 'error' : ''}`}>
                            <label className="pb-3px">Location</label>
                            <div className="input form-group ar-multiple-br m-0">
                                <SuperSearchList
                                    is={is}
                                    type="client"
                                    id='Facility'
                                    name='Facility'
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    searchValue={searchValue.Facility}
                                    data={locationDD}
                                    onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, Facility: e.target.value }) }}
                                    getSelectedData={handleSelectedData}
                                    placeholder={false}
                                    inputError={encounterDetailsValidationModal?.FacilityVal}
                                />
                                {encounterDetailsValidationModal.FacilityVal}
                            </div>
                        </div>

                        <div className={`input form-group ar-multiple-br m-0 ${encounterDetailsValidationModal.EncounterTypeVal ? 'error' : ''}`}>
                            <label className="pb-3px">Encounter Type</label>
                            <SuperSearchList
                                type="client"
                                id='EncounterType'
                                name='EncounterType'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValue.EncounterType}
                                data={visitTypes}
                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterType: e.target.value }) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                                placeholder={false}
                                inputError={encounterDetailsValidationModal?.EncounterTypeVal}
                            />
                            {encounterDetailsValidationModal?.EncounterTypeVal}
                        </div>

                        <div className={`form-group input mb-0 ${encounterDetailsValidationModal.NoteTypeVal ? 'error' : ''}`}>
                            <label className="pb-3px">Note Type</label>
                            <div className="input form-group ar-multiple-br m-0">
                                <SuperSearchList
                                    type="client"
                                    id='NoteType'
                                    name='NoteType'
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    searchValue={searchValue.NoteType}
                                    // data={noteTypes}
                                    data={handleSetDropdownData(noteTypes, {functions: ['setEmptyDefault']})}
                                    onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, NoteType: e.target.value }) }}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    placeholder={false}
                                    inputError={encounterDetailsValidationModal?.NoteTypeVal}
                                    isReadOnly={(saveEncounterParam?.CopyFromEncounterID) ? true : false}
                                    disabled={(saveEncounterParam?.CopyFromEncounterID) ? true : false}
                                />
                                {encounterDetailsValidationModal.NoteTypeVal}
                            </div>
                        </div>
                    </div>
                    {/* )} */}
                    {/* {selectedOption === 'SelectDate' && (
                        <div className="d-flex flex-column gap-2">
                            <div className="">
                                <DatePicker />
                            </div>

                            <div className="form-group input mb-0">
                                <label className="pb-3px">Provider</label>
                                <div className="input form-group ar-multiple-br m-0">
                                    <SuperSearchList
                                        type="provider"
                                        id="ProviderType"
                                        name="ProviderType"
                                        icon="Simple"
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>

                            <div className="form-group input mb-0">
                                <label className="pb-3px">Location</label>
                                <div className="input form-group ar-multiple-br m-0">
                                    <SuperSearchList
                                        type="location"
                                        id="LocationType"
                                        name="LocationType"
                                        icon="Simple"
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>

                            <div className="form-group input mb-0">
                                <label className="pb-3px">Encounter Type</label>
                                <div className="input form-group ar-multiple-br m-0">
                                    <SuperSearchList
                                        type="encounter"
                                        id="EncounterType"
                                        name="EncounterType"
                                        icon="Simple"
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>

                            <div className="form-group input mb-0">
                                <label className="pb-3px">Note Type</label>
                                <div className="input form-group ar-multiple-br m-0">
                                    <SuperSearchList
                                        type="note"
                                        id="NoteType"
                                        name="NoteType"
                                        icon="Simple"
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                    />
                                </div>
                            </div>
                        </div>
                    )} */}


                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-end">
                    <div className="btns-group">
                        <button className={`btn btn-validate px-10 h-100 d-flex align-items-center gap-1 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSave}>
                            Proceed
                            <i className="icon-Symbol-24--25 text-white fs-12"></i>
                        </button>
                    </div>
                </div>

            </Modal>
        </>
    )
}


function mapStateToPropss(state) {
    return {
        OpenDynamicTab: state.Open_Encounter_Tab ? state.Open_Encounter_Tab : [],
        Settings: state.SettingsReducer,
    };
}

const action = {
    // TabActionEncounters,
};

export default connect(mapStateToPropss, action)(EncounterSearch);